// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-wrapper-section {
  padding: 0px 5px 12px 16px;
  overflow: scroll;
  display: inline-block;
  width: 100%;
}

.table-regular-view {
  border-radius: 4px;
  border: 1px solid var(--sdk-gloabl-border-color);
  width: 100%;
}
.table-regular-view thead th {
  padding: 8px 12px;
  border-bottom: 1px solid var(--table-border);
  color: var(--table-header-text-color);
  font-size: 11px;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  text-align: start;
}
.table-regular-view tbody tr:nth-child(odd) td {
  background: var(--table-body-tr-bg);
}
.table-regular-view tbody tr:last-child td {
  border: 0;
}
.table-regular-view tbody td {
  padding: 12px;
  text-align: start;
  border-bottom: 1px solid var(--table-border);
  color: var(--table-header-text-color);
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
}
.table-regular-view tbody td.clickable-btn {
  cursor: pointer;
  color: var(--sdk-global-theme-color);
  font-weight: 500;
}
.table-regular-view tbody td.clickable-link {
  text-decoration: underline;
}

.table-response-wrapper-container {
  padding: 12px 10px 12px 16px;
}
.table-response-wrapper-container .table-response-wrapper {
  border-radius: 4px;
  border: 1px solid var(--sdk-gloabl-border-color);
}
.table-response-wrapper-container .table-response-wrapper .acc-block-content {
  display: flex;
  align-items: center;
  border-bottom: 1px solid var(--table-border);
}
.table-response-wrapper-container .table-response-wrapper .acc-block-content:last-child {
  border: 0;
}
.table-response-wrapper-container .table-response-wrapper .acc-block-content:nth-child(odd) {
  background: var(--table-body-tr-bg);
}
.table-response-wrapper-container .table-response-wrapper .acc-block-content.acc-open {
  position: relative;
  padding-right: 71px;
  flex-wrap: wrap;
}
.table-response-wrapper-container .table-response-wrapper .acc-block-content.acc-open .info-block {
  flex: 1 1 50% !important;
}
.table-response-wrapper-container .table-response-wrapper .acc-block-content.acc-open .info-block h1 {
  display: block;
}
.table-response-wrapper-container .table-response-wrapper .acc-block-content.acc-open .icon-block {
  position: absolute;
  right: 0;
  top: 0;
  z-index: 2;
}
.table-response-wrapper-container .table-response-wrapper .acc-block-content.acc-open .icon-block svg {
  transform: rotate(90deg);
}
.table-response-wrapper-container .table-response-wrapper .acc-block-content.acc-open .hide {
  display: block;
}
.table-response-wrapper-container .table-response-wrapper .acc-block-content .info-block {
  padding: 12px;
  width: 100%;
}
.table-response-wrapper-container .table-response-wrapper .acc-block-content .info-block:first-child {
  min-width: 35px;
  flex-shrink: 0;
  text-align: start;
  max-width: 80px;
}
.table-response-wrapper-container .table-response-wrapper .acc-block-content .info-block:first-child p {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.table-response-wrapper-container .table-response-wrapper .acc-block-content .info-block h1 {
  color: var(--gray-modern-500, var(--table-desc-text-color));
  font-size: 11px;
  font-weight: 500;
  line-height: 16px;
  margin-bottom: 3px;
}
.table-response-wrapper-container .table-response-wrapper .acc-block-content .info-block p {
  color: var(--table-header-text-color);
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
}
.table-response-wrapper-container .table-response-wrapper .acc-block-content .icon-block {
  display: flex;
  width: 71px;
  height: 42px;
  padding: 12px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  cursor: pointer;
}
.table-response-wrapper-container .table-response-wrapper .acc-block-content .icon-block svg {
  width: 16px;
  height: 16px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.table-response-wrapper-container .table-response-wrapper .acc-block-content .icon-block svg path {
  stroke: var(--sdk-gloabl-text-color);
}
.table-response-wrapper-container .table-response-wrapper .acc-block-content .hide {
  display: none;
}

.show-more-btn, .kore-chat-window-main-section .show-more-btn {
  padding: 8px;
  color: var(--sdk-global-theme-color);
  text-align: center;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  border: 0;
  background: transparent;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/templatemanager/templates/table/table.scss"],"names":[],"mappings":"AACA;EACI,0BAAA;EACA,gBAAA;EACA,qBAAA;EACA,WAAA;AAAJ;;AAEA;EACI,kBAAA;EACA,gDAAA;EACA,WAAA;AACJ;AACQ;EACI,iBAAA;EACA,4CAAA;EACA,qCAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,yBAAA;EACA,iBAAA;AACZ;AAKgB;EACI,mCAAA;AAHpB;AAOgB;EACI,SAAA;AALpB;AASQ;EACI,aAAA;EACA,iBAAA;EACA,4CAAA;EACA,qCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAPZ;AAQY;EACI,eAAA;EACA,oCAAA;EACA,gBAAA;AANhB;AAQY;EACI,0BAAA;AANhB;;AAYA;EACI,4BAAA;AATJ;AAUI;EACI,kBAAA;EACA,gDAAA;AARR;AASQ;EACI,aAAA;EACA,mBAAA;EACA,4CAAA;AAPZ;AAQY;EACI,SAAA;AANhB;AAQY;EACI,mCAAA;AANhB;AAQY;EACI,kBAAA;EACA,mBAAA;EACA,eAAA;AANhB;AAOgB;EACI,wBAAA;AALpB;AAMoB;EACI,cAAA;AAJxB;AAOgB;EACI,kBAAA;EACA,QAAA;EACA,MAAA;EACA,UAAA;AALpB;AAMoB;EACI,wBAAA;AAJxB;AAOgB;EACI,cAAA;AALpB;AAQY;EACI,aAAA;EACA,WAAA;AANhB;AAOgB;EACI,eAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;AALpB;AAMoB;EACI,gBAAA;EACA,mBAAA;EACA,uBAAA;AAJxB;AAOgB;EACI,2DAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AALpB;AAOgB;EACI,qCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AALpB;AAQY;EACI,aAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;EACA,eAAA;AANhB;AAOgB;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AALpB;AAMoB;EACI,oCAAA;AAJxB;AAQY;EACI,aAAA;AANhB;;AAWA;EACI,YAAA;EACA,oCAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,SAAA;EACA,uBAAA;EACA,eAAA;AARJ","sourcesContent":["\n.table-wrapper-section{\n    padding: 0px 5px 12px 16px;\n    overflow: scroll;\n    display: inline-block;\n    width: 100%;\n}\n.table-regular-view{\n    border-radius: 4px;\n    border: 1px solid var(--sdk-gloabl-border-color);\n    width: 100%;\n    thead{\n        th{\n            padding: 8px 12px;\n            border-bottom: 1px solid var(--table-border);\n            color: var(--table-header-text-color);\n            font-size: 11px;\n            font-weight: 600;\n            line-height: normal;\n            letter-spacing: 0.5px;\n            text-transform: uppercase;\n            text-align: start;\n        }\n    }\n    tbody{\n        tr{\n            &:nth-child(odd){\n                td{\n                    background: var(--table-body-tr-bg);\n                }\n            }\n            &:last-child{\n                td{\n                    border: 0;\n                }\n            }\n        }\n        td{\n            padding: 12px;\n            text-align: start;\n            border-bottom: 1px solid var(--table-border);\n            color: var(--table-header-text-color);\n            font-size: 12px;\n            font-weight: 400;\n            line-height: 18px;\n            &.clickable-btn{\n                cursor: pointer;\n                color: var(--sdk-global-theme-color);\n                font-weight: 500;\n            }\n            &.clickable-link{\n                text-decoration: underline;\n            }\n        }\n    }\n}\n\n.table-response-wrapper-container{\n    padding: 12px 10px 12px 16px;\n    .table-response-wrapper{\n        border-radius: 4px;\n        border: 1px solid var(--sdk-gloabl-border-color);\n        .acc-block-content{\n            display: flex;\n            align-items: center;\n            border-bottom: 1px solid var(--table-border);\n            &:last-child{\n                border: 0;\n            }\n            &:nth-child(odd){\n                background: var(--table-body-tr-bg);\n            }\n            &.acc-open{\n                position: relative;\n                padding-right: 71px;\n                flex-wrap: wrap;\n                .info-block{\n                    flex: 1 1 50% !important;\n                    h1{\n                        display: block;\n                    }                    \n                }\n                .icon-block{\n                    position: absolute;\n                    right: 0;\n                    top: 0;\n                    z-index: 2;\n                    svg{\n                        transform: rotate(90deg);\n                    }\n                }\n                .hide {\n                    display: block;\n                }\n            }\n            .info-block{                \n                padding: 12px;\n                width: 100%;\n                &:first-child{\n                    min-width: 35px;\n                    flex-shrink: 0;\n                    text-align: start;\n                    max-width: 80px;\n                    p{\n                        overflow: hidden;\n                        white-space: nowrap;\n                        text-overflow: ellipsis;\n                    }\n                }\n                h1{\n                    color: var(--gray-modern-500, var(--table-desc-text-color));\n                    font-size: 11px;\n                    font-weight: 500;\n                    line-height: 16px;\n                    margin-bottom: 3px;\n                }\n                p{\n                    color: var(--table-header-text-color);\n                    font-size: 12px;\n                    font-weight: 400;\n                    line-height: 18px;\n                }\n            }\n            .icon-block{\n                display: flex;\n                width: 71px;\n                height: 42px;\n                padding: 12px;\n                justify-content: center;\n                align-items: center;\n                gap: 10px;\n                flex-shrink: 0;\n                cursor: pointer;\n                svg{\n                    width: 16px;\n                    height: 16px;\n                    text-align: center;\n                    display: flex;\n                    align-items: center;\n                    justify-content: center;\n                    path{\n                        stroke: var(--sdk-gloabl-text-color);\n                    }\n                }\n            }\n            .hide{\n                display: none;\n            }\n        }\n    }\n}\n.show-more-btn{\n    padding: 8px;\n    color: var(--sdk-global-theme-color);\n    text-align: center;\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 18px;\n    border: 0;\n    background: transparent;\n    cursor: pointer;\n}\n\n.kore-chat-window-main-section .show-more-btn{\n    @extend .show-more-btn;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
